'use client';

import { useCerFeatures } from './use-cer-features';

import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/utils/api';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Quante raccomandazioni AI adottate hanno agito nel mese in corso
 * (`GET /api/ai-recommendations/actions`). `null` finché non c'è il dato o se
 * la CER non ha i suggerimenti AI attivi.
 */
export function useAiActionsCount(orgId: string | null | undefined): number | null {
	const loaded = useAuthStore((s) => s.loaded);
	const { features } = useCerFeatures(orgId);
	const enabled = loaded && !!orgId && features.aiSuggestions === 'enabled';

	const { data } = useQuery({
		queryKey: ['ai-actions', orgId],
		enabled,
		queryFn: () =>
			api.get<{ month: string; count: number }>('/api/ai-recommendations/actions', {
				orgId: orgId as string,
			}),
	});

	return enabled ? (data?.count ?? null) : null;
}
